<template>
  <v-dialog v-model="dialog"
            max-width="500px"
            persistent
  >
    <v-card>
      <v-toolbar color="primary"
                 dark
                 flat
                 dense
      >
        <v-toolbar-title class="text-h6">
          Editar Clientes - {{ credential ? credential.name : '' }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon
               :disabled="saving"
               @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-form ref="form"
                v-model="valid"
        >
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedCustomers"
                :items="customerList"
                item-text="name"
                item-value="_id"
                label="Clientes Associados (Bancos de Dados)"
                multiple
                chips
                small-chips
                deletable-chips
                dense
                outlined
                :rules="[v => v && v.length > 0 || 'Selecione pelo menos um cliente']"
                hint="Quais clientes esta credencial terá acesso?"
                persistent-hint
              >
                <template #selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1"
                        class="grey--text text-caption ml-2"
                  >
                    (+{{ selectedCustomers.length - 1 }} clientes)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn
          color="error"
          text
          class="rounded-pill px-4"
          :disabled="saving"
          @click="close"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          class="rounded-pill px-4"
          :disabled="!valid"
          :loading="saving"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { $k } from '@/lib/kraken'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'EditCredentialCustomersDialog',
    data: () => ({
      dialog: false,
      valid: false,
      saving: false,
      credential: null,
      selectedCustomers: [],
    }),
    computed: {
      ...mapGetters('customers', ['customerList']),
    },
    methods: {
      ...mapActions('customers', ['listCustomers']),
      async openDialog(credential) {
        this.credential = credential
        this.dialog = true
        this.valid = false
        this.saving = false
      
        // Extract existing customers
        if (credential.associatedClinicUsers) {
          this.selectedCustomers = credential.associatedClinicUsers.map(c => c.customerId)
        } else {
          this.selectedCustomers = []
        }

        if (this.$refs.form) this.$refs.form.resetValidation()

        await this.listCustomers()
      },
      close() {
        this.dialog = false
        this.credential = null
      },
      async save() {
        if (!this.$refs.form.validate()) return

        this.saving = true
        try {
          const integrationId = this.credential.services?.integration?.integrationId || ''
        
          const associatedClinicUsers = this.selectedCustomers.map(customerId => {
            const customer = this.customerList.find(c => c._id === customerId)
            return {
              enabled: true,
              customerId: customerId,
              customerCode: customer.code,
              clinicUser: `i:${integrationId}`,
              clinicUsername: this.credential.name,
              service: 'legacy',
            }
          })

          await $k.manage.users._id.put({
            id: this.credential._id,
            associatedClinicUsers: associatedClinicUsers,
          })

          if (this.$alert) this.$alert('success', 'Clientes atualizados com sucesso')
          this.$emit('updated')
          this.close()
        } catch (error) {
          console.error(error)
          if (this.$alert) this.$alert('error', 'Erro ao atualizar clientes')
        } finally {
          this.saving = false
        }
      },
    },
  }
</script>

<style scoped>
.v-btn.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}
</style>
